import { jsx as l, jsxs as m } from "react/jsx-runtime";
import { twMerge as r } from "tailwind-merge";
const y = ({
  description: t,
  descriptionClassName: e,
  error: n,
  errorClassName: s,
  className: i
}) => {
  const a = !n || Array.isArray(n) && !n.length ? null : /* @__PURE__ */ l(
    "p",
    {
      className: r("primary-link-container text-danger text-sm", s),
      ...typeof n == "string" ? {
        dangerouslySetInnerHTML: { __html: n }
      } : {
        children: n
      }
    }
  );
  return n || t ? /* @__PURE__ */ m("div", { className: i, children: [
    t ? /* @__PURE__ */ l(
      "span",
      {
        className: r("primary-link-container text-sm opacity-70", e),
        children: t
      }
    ) : null,
    a
  ] }) : null;
};
export {
  y as FieldErrorAndDescription
};
